import React from "react";

const PORTRAIT_URL = "/images/who-am-i-portrait.jpg";

export default function WhoAmISection() {
  return (
    <section
      id="rolam"
      data-testid="whoami-section"
      className="relative pt-6 md:pt-8 pb-10 md:pb-14 px-6 md:px-10"
    >
      <div className="max-w-5xl mx-auto">
        {/* Centered eyebrow + title */}
        <p
          data-testid="whoami-section-eyebrow"
          className="text-[12px] tracking-[0.35em] uppercase text-gold mb-5 font-body text-center"
        >
          — Találkozás
        </p>
        <h2
          data-testid="whoami-section-title"
          className="font-serif-display text-[34px] sm:text-[40px] md:text-[46px] leading-[1.15] text-graphite mb-10 text-center"
        >
          <em className="text-gold" style={{ fontStyle: "italic" }}>Ki vagyok</em> én?
        </h2>

        {/* Portrait + signature quote — side-by-side on desktop, stacked on mobile */}
        <div className="my-6 md:my-10 grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-10 items-center">
          {/* Portrait — smaller, elegant */}
          <figure className="md:col-span-7">
            <div className="portrait-frame relative max-w-sm mx-auto">
              <img
                data-testid="whoami-portrait"
                src={PORTRAIT_URL}
                alt="Szász-Tóth Enikő portréfotó"
                className="w-full h-[440px] md:h-[500px] object-cover"
                style={{
                  filter: "saturate(1.0) contrast(1.0) sepia(0.06)",
                }}
              />
            </div>
            <figcaption className="text-center mt-4 font-serif-display italic text-graphite-soft text-[14px]">
              Szász-Tóth Enikő
            </figcaption>
          </figure>

          {/* Signature quote — uniform size, single visual rhythm */}
          <div className="md:col-span-5 text-center md:text-left">
            <p className="font-serif-display italic text-gold text-[22px] sm:text-[24px] md:text-[26px] leading-[1.45]">
              Nő.
              <br />
              Feleség.
              <br />
              Édesanya.
              <br />
              Mindenekelőtt pedig ember.
            </p>
          </div>
        </div>

        {/* Body — verbatim from the brief */}
        <div className="reading-prose mt-10 text-[16px] md:text-[17px] leading-[1.9] text-graphite font-body font-light">
          <p>
            Az élet egyik legfontosabb tanítása számomra az volt, hogy minden kapcsolat hordoz
            valamilyen ajándékot. Még azok is, amelyeket a legnehezebbnek élünk meg. Sokáig azt
            keressük, hogyan változtassuk meg a másikat. Később rájövünk, hogy a valódi kérdés
            egészen más. Mit szeretne megmutatni számunkra ez a találkozás? Egy idő után elkezdtem
            észrevenni azt, hogy legnehezebb helyzetek mögött is ott volt valami, ami többet akart
            mutatni annál, mint amit elsőre láttam. A legtöbbször nem válaszra van szükségünk.
            Hanem egy olyan térre, ahol végre más szemszögből nézhetünk rá önmagunkra, a
            kapcsolatainkra és az életünkre. Hiszem, hogy az emberek többsége nem gyenge, nem
            motiválatlan és nem elrontott. Sokkal inkább eltávolodott attól, aki valójában
            lehetne. Hiszem, hogy minden emberben ott van egy természetes belső rend és egy olyan
            lehetőség, amely sokszor csak arra vár, hogy végre láthatóvá váljon. Az erre rakódott
            „zűrzavar" kiigazításában segítek. Talán ezért érdekel jobban az, ami a felszín alatt
            működik, mint maga a felszín. Különösen a történetek mögött rejlő mozgató rugók. Mert
            amikor ezeket felismerjük, az addig rejtett lehetőségek is megmutatkoznak. A munkám
            során nem kész válaszokat adok… Sokkal inkább segítek meglátni azokat az
            összefüggéseket, amelyek mindig is ott voltak.
          </p>

          <div className="my-6 md:my-8 text-center">
            <p className="font-serif-display italic text-[24px] sm:text-[28px] md:text-[32px] leading-[1.35] text-gold max-w-xl mx-auto">
              Mert gyakran egyetlen felismerés
              <br />
              többet változtat az életünkön,
              <br />
              mint száz jó tanács.
            </p>
          </div>
        </div>
      </div>

      <div className="max-w-5xl mx-auto mt-10 md:mt-12 hairline" />
    </section>
  );
}
